// extracted by mini-css-extract-plugin
export default {"main":"SettingsMenu_main__+KL-6","button":"SettingsMenu_button__4hnkl","menu":"SettingsMenu_menu__M8MQd"};